<template>
  <div>
    <Logs :showForm="showLogs" :formData="formData" />
    <Agendamento :showForm="showAgendamento" />

    <div>
      <div class="esocial-toolbar">
        <div class="esocial-tabs" v-if="!lote && !avulso">
          <div
            v-for="tabela in config.list.esocial_tabela"
            :key="tabela.id"
            class="esocial-tabs__item"
            :class="{ 'is-active': formData.layout == tabela.codigo }"
            @click="formData.layout = tabela.codigo"
          >
            <i class="fa fa-file-code-o"></i>
            <span>{{ tabela.codigo }}</span>
          </div>
        </div>

        <div class="esocial-search">
          <div class="esocial-search__group">
            <div class="esocial-search__input">
              <i class="fa fa-search"></i>
              <input
                type="text"
                v-model="formData.search"
                :placeholder="
                  lote
                    ? 'Pesquisar por Empresa, Funcionário...'
                    : 'Pesquisar por Consulta, Recibo, Lote, Funcionário, Empresa...'
                "
                @keyup.enter="getEsocial(formData.search)"
              />
            </div>
            <button type="button" class="esocial-search__btn esocial-search__btn--attached" @click="getEsocial(formData.search)">
              <i class="fa fa-search"></i> Buscar
            </button>
          </div>
          <button type="button" v-if="avulso" class="esocial-search__btn esocial-search__btn--filter" @click="onRegister">
            <i class="fa fa-plus"></i> Inserir novo XML
          </button>
          <button type="button" v-if="!lote" class="esocial-search__btn esocial-search__btn--filter" @click="showFilterModal = true">
            <i class="fa fa-filter"></i> Filtrar
            <span class="esocial-search__badge" v-if="filterBadge > 0">{{ filterBadge }}</span>
          </button>
          <button type="button" class="esocial-search__btn" @click="showAgendamento = !showAgendamento" title="Rotinas Automáticas">
            <i class="fa fa-clock-o"></i>
          </button>
        </div>
      </div>

      <esocial-tabela
        :tableHead="tableHead"
        :tableData="tableData"
        :loadingTable="config.loading.table"
        :pagination="pagination"
        :response="response"
        :search="formData.search"
        :onSearch="getEsocial"
        :onBulkGerarXml="lote || avulso ? null : onBulkGerarXml"
        :onBulkWhatsapp="lote || avulso ? null : onBulkDispararWhatsappAtualizarMatriculaContador"
        :disableCheckAll="!!lote || !!avulso"
        :loadingRowIds="loadingRowIds"
      />

      <transition name="esocial-modal-fade">
        <div class="esocial-modal-overlay" v-if="showFilterModal" @click.self="showFilterModal = false">
          <div class="esocial-modal">
            <div class="esocial-modal__header">
              <span class="esocial-modal__title">Filtrar Resultado</span>
              <button type="button" class="esocial-modal__close" @click="showFilterModal = false">
                <i class="fa fa-times"></i>
              </button>
            </div>

            <div class="esocial-modal__body">
              <Filters :parent="this" v-if="showFilterModal" />
            </div>

            <div class="esocial-modal__footer">
              <button type="button" class="esocial-search__btn" @click="onClear(); showFilterModal = false">
                <i class="fa fa-refresh"></i> Limpar
              </button>
              <button type="button" class="esocial-search__btn esocial-search__btn--filter" @click="getEsocial(formData.search); showFilterModal = false">
                <i class="fa fa-filter"></i> Filtrar
              </button>
            </div>
          </div>
        </div>
      </transition>

      <s0000
        v-if="avulso" :parent="this"
      ></s0000>
       <s2210
        v-else-if="
          !config.loading.table &&
          formData.layout &&
          formData.layout == 'S-2210'
        "
        :parent="this"
      ></s2210>
      <s2220
        v-else-if="
          !config.loading.table &&
          formData.layout &&
          formData.layout == 'S-2220'
        "
        :parent="this"
      ></s2220>
      <s2240
        v-else-if="
          !config.loading.table &&
          formData.layout &&
          formData.layout == 'S-2240'
        "
        :parent="this"
      ></s2240>
      <s3000
        v-else-if="
          !config.loading.table &&
          formData.layout &&
          formData.layout == 'S-3000'
        "
        :parent="this"
      ></s3000>
    </div>

    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay" v-if="showModalUid" @click.self="showModalUid = false">
        <div class="esocial-modal">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Atualizar dados do evento</span>
            <button type="button" class="esocial-modal__close" @click="showModalUid = false">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body">
            <el-form :model="{ novoUid }" ref="ruleForm">
              <ed-alert class="px-3 mt-2" title="Atenção" type="warning">
                <p slot="description">
                  Se o campo recibo for preenchido ou atualizado, o sistema alterará o status para "Processado com sucesso". Caso fique vazio, ele não altera o status atual do evento. A edição manual do recibo fica registrada (usuário e data).
                </p>
              </ed-alert>
              <ed-alert class="px-3 mt-2" title="Já editado manualmente" type="info" v-if="reciboManualInfo">
                <p slot="description">
                  O recibo deste evento já foi alterado manualmente por <b>{{ reciboManualInfo.usuario }}</b> em {{ reciboManualInfo.data }}.
                </p>
              </ed-alert>
              <ed-input-text class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" label="Atualizar UID" v-model="novoUid" name="novoUid" required/>
              <ed-input-text class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" label="Adicionar/atualizar recibo" v-model="novoRecibo" name="novoRecibo" required/>
            </el-form>
          </div>

          <div class="esocial-modal__footer">
            <button type="button" class="esocial-search__btn esocial-search__btn--filter" @click="saveUid">
              <i class="fa fa-check"></i> Salvar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="esocial-modal-fade">
      <div class="esocial-modal-overlay" v-if="showModalDownloadXML" @click.self="showModalDownloadXML = false">
        <div class="esocial-modal esocial-modal--xml">
          <div class="esocial-modal__header">
            <span class="esocial-modal__title">Arquivo XML {{ xmlPreview.filename }}</span>
            <button type="button" class="esocial-modal__close" @click="showModalDownloadXML = false">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="esocial-modal__body esocial-modal__body--xml">
            <div class="esocial-tabs esocial-tabs--xml">
              <div
                class="esocial-tabs__item"
                :class="{ 'is-active': xmlViewMode == 'arvore' }"
                @click="xmlViewMode = 'arvore'"
              >
                <i class="fa fa-code"></i>
                <span>Árvore</span>
              </div>
              <div
                class="esocial-tabs__item"
                :class="{ 'is-active': xmlViewMode == 'tabela' }"
                @click="xmlViewMode = 'tabela'"
              >
                <i class="fa fa-table"></i>
                <span>Tabela</span>
              </div>
            </div>

            <div class="xml-preview" v-if="xmlViewMode == 'arvore'">
              <XmlViewer :xml="xmlPreview.content" v-if="xmlPreview.content" />
            </div>

            <div class="xml-table" v-if="xmlViewMode == 'tabela'">
              <table>
                <thead>
                  <tr>
                    <th>Campo</th>
                    <th>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(campo, i) in xmlPreview.campos" :key="i">
                    <td class="xml-table__campo">{{ campo.caminho }}</td>
                    <td class="xml-table__valor">{{ campo.valor }}</td>
                  </tr>
                </tbody>
              </table>

              <div v-if="!xmlPreview.campos.length" class="xml-table__empty">Nenhum campo encontrado no XML.</div>
            </div>
          </div>

          <div class="esocial-modal__footer">
            <button type="button" class="esocial-modal__btn-download" @click="downloadXMLPreview">
              <i class="fa fa-download"></i> Baixar arquivo XML
            </button>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import Rest from "common/rest";
import Fct from "common/fct";
import XmlViewer from "vue-xml-viewer";
import { EdAlert, EdInputText } from "template";
import Logs from "./includes/logs";
import Filters from "./includes/filter";
import EsocialTabela from "./includes/tabela";
import Agendamento from "./includes/agendamento";

//layouts
import s0000 from "./s0000";
import s2210 from "./s2210";
import s2220 from "./s2220";
import s2240 from "./s2240";
import s3000 from "./s3000";

export default {
  name: "esocial",
  mixins: [Rest, Fct],
  components: {
    EsocialTabela,
    Filters,
    Logs,
    Agendamento,
    s0000,
    s2220,
    s2210,
    s2240,
    s3000,
    EdAlert,
    EdInputText,
    XmlViewer
  },
  watch: {
    "formData.layout"(codigo) {
      this.formData.esocial_tabela = (this.config.list.esocial_tabela || []).find(
        (tabela) => tabela.codigo == codigo
      ) || null;

      this.formFilter = {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico:0,
        avulso:this.avulso,
        data_cadastro: [],
        mostrar: [],
        id_tipo_status: [],
        motivo_falha_geracao: [],
        tp_exa: [],
      };
      this.getEsocial(null, null, null);
    },
    "layout"() {
      this.formData.layout = this.layout
    },
    "lote"() {
      this.getEsocial(null, null, null)
    },
  },
  props: {
    layout: {
      type: String,
      default: function () {
        return null;
      },
    },
    lote: {
      type: [String,Number],
      default: function () {
        return null;
      },
    },
    avulso: {
      type: [Number],
      default: function () {
        return 0;
      },
    },
  },
  data() {
    return {
      config: {
        loading: {
          esocial_tabela: false,
          content: false,
          table: false,
          tableAntigo: false,
        },
        list: {
          esocial_tabela: [],
        },
      },
      formData: {
        layout: null,
        esocial_tabela:null,
        item: null,
        search: null,
        page: null,
        pagination: null,
        filter: null,
        empresa: null,
        arquivoConfig: {},
        result: {},
      },
      formDataXml:{

      },
      formFilter: {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico:0,
        avulso:1,
        data_cadastro: [],
        mostrar: [],
        id_tipo_status: [],
        motivo_falha_geracao: [],
        tp_exa: [],
      },
      pagination: {},
      response: {},
      loadingRowIds: [],
      filterBadge: 0,
      showFilterModal: false,
      showAgendamento: false,
      showLogAntigo:false,
      showNovoXml:false,
      paginationAntigo: {},
      responseAntigo: {},
      filterBadgeAntigo: 0,
      tableHead: [],
      tableData: [],
      tableHeadAntigo: [],
      tableDataAntigo: [],
      showLogs: false,
      showModalUid: false,
      novoUid: null,
      novoRecibo: null,
      olduid: null,
      reciboManualInfo: null,
      showModalDownloadXML: false,
      xmlViewMode: "arvore",
      xmlPreview: {
        content: null,
        filename: null,
        blob: null,
        campos: [],
      },
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() {},

  mounted() {
    this.getEsocialTabela();
  },

  methods: {

    onClear(){
      this.formFilter = {
        id_empresa: null,
        id_fdt: null,
        id_funcionario: null,
        empresa_envio_automatico:0,
        avulso:this.avulso,
        data_cadastro: [],
        mostrar: [],
        id_tipo_status:[],
        motivo_falha_geracao: [],
        tp_exa: []
      },

      this.getEsocial(null, null, null)
    },

    onRegister(){
      this.formDataXml = {}
      this.showNovoXml = !this.showNovoXml
    },

    onEditXml(data) {
      this.showNovoXml = !this.showNovoXml
      this.formDataXml = Object.assign(data,{})
    },


    onEdit(data) {
      this.gerarArquivoXMLLinha(data);
    },

    escapeHtml(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
    },

    // Gera o XML de UMA linha só: mostra loading só nela e atualiza só os dados
    // dela na tabela, sem recarregar a listagem inteira (nem resetar página/scroll).
    gerarArquivoXMLLinha(data) {
      var id = data.id;
      var layout = data.layout;
      var jaTemXml = !!data.xml;
      var nomeFuncionario = data.funcionario ? data.funcionario.nome : null;
      var nomeEmpresa = data.empresa ? data.empresa.nome : null;

      var mensagem =
        '<div class="esocial-confirm">' +
        '<p class="esocial-confirm__lead">' +
        (jaTemXml
          ? "O XML já gerado para este registro será <b>substituído</b> por um novo."
          : "Um novo XML será gerado para este registro e enviado ao próximo lote do eSocial.") +
        "</p>" +
        (nomeFuncionario
          ? '<div class="esocial-confirm__alvo">' +
            '<i class="fa fa-user-circle-o"></i>' +
            "<div>" +
            "<strong>" +
            this.escapeHtml(nomeFuncionario) +
            "</strong>" +
            (nomeEmpresa ? "<span>" + this.escapeHtml(nomeEmpresa) + "</span>" : "") +
            "</div>" +
            "</div>"
          : "") +
        "</div>";

      this.$confirm(mensagem, "Gerar XML do eSocial", {
        confirmButtonText: jaTemXml ? "Sim, substituir XML" : "Gerar XML",
        cancelButtonText: "Cancelar",
        type: "warning",
        dangerouslyUseHTMLString: true,
        customClass: "esocial-confirm-box",
      }).then(() => {
        if (this.loadingRowIds.indexOf(id) === -1) {
          this.loadingRowIds = this.loadingRowIds.concat([id]);
        }

        var targetLayout = layout ? layout : this.formData.layout;

        this.get("esocial/" + targetLayout + "/gerar-arquivo-xml", {
          filter: { ids: [id], avulso: this.avulso },
        })
          .then((result) => {
            result = result[0];

            if (result.status == 200) {
              this.edMsg("Operação realizada com sucesso");
            } else {
              this.edAlert(result.msg, "error");
            }

            return this.atualizarLinha(id);
          })
          .finally(() => {
            this.loadingRowIds = this.loadingRowIds.filter((rowId) => rowId != id);
          });
      });
    },

    // Busca só o registro `id` já atualizado e substitui ele dentro de response.data.data,
    // sem tocar no resto da tabela (paginação, filtro, scroll ficam intactos).
    atualizarLinha(id) {
      return this.get("esocial/" + this.formData.layout, {
        filter: { ids: [id], avulso: this.avulso },
      }).then((result) => {
        result = result[0];

        if (result.status != 200 || !result.data || !result.data.data || !result.data.data.length) return;

        var atualizado = result.data.data[0];
        var lista = (this.response.data && this.response.data.data) || [];
        var idx = lista.findIndex((item) => item.id == id);

        if (idx === -1) return;

        var novaLista = lista.slice();
        novaLista[idx] = atualizado;

        this.response = Object.assign({}, this.response, {
          data: Object.assign({}, this.response.data, { data: novaLista }),
        });
      });
    },

    onDelete(data) {

      let arrayExcluir = []
      let avulso = false

      if(data && data.id){
        arrayExcluir.push(data.id)

        if(data.avulso == '1' && [328].indexOf(data.tipo_status.id) != -1){
          avulso = true
        }
      }

      if(!arrayExcluir.length){
         this.edAlert(
          "Arquivo indispoível para exclusão.","error"
        );
        return;
      }

      let msg = "O sistema vai excluir "+arrayExcluir.length+" arquivo(s) diretamente no eSocial e o processo não poderá ser desfeito. Deseja prosseguir?"

      if(!data.recibo){
        msg = "O sistema vai excluir "+arrayExcluir.length+" arquivo(s) e o processo não poderá ser desfeito. Deseja prosseguir?"
      }

      this.$confirm(msg,
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.$root.$loading.set(true);
        this.config.loading.content = true;

        var filter = {
          ids: [data.id],
        };

        var empresa_id = null;

        this.post(
          "esocial/" + this.formData.layout+"/deletar",
          { ids: arrayExcluir }
        ).then((result) => {
          result = result[0];
          this.config.loading.content = false;
          this.$root.$loading.set(false);

          this.getEsocial();

          if (result.status == 200) {

            if(avulso){
              this.edAlert(
              "Evento excluído com sucesso."
            );
            }
            else{
              this.edAlert(
              "Evento de exclusão enviado para o eSocial."
            );
            }
            
          }
        });
      });
    },

    onGerarLote(data) {
      this.$confirm(
        "O sistema já faz esta verificação diariamente automaticamente e cria os lotes necessários. Deseja verificar agora se existem novos lotes?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.config.loading.content = true;
        this.$root.$loading.set(true);

        var filter = {
          ids: [data.id],
          avulso:this.avulso
        };

        var empresa_id = null;

        if (data.empresa) {
          empresa_id = data.empresa.id;
        } else if (data.ghe && data.ghe.ltcat) {
          empresa_id = data.ghe.ltcat.empresa.id;
        }

        this.get(
          "esocial/lotes/gerar/" + data.layout + "/" + empresa_id,
          { filter: filter }
        ).then((result) => {
          result = result[0];
          this.config.loading.content = false;
          this.$root.$loading.set(false);

          this.getEsocial();

          if (result.status == 200) {
            this.edAlert(
              "Processo de cadastro do LOTE iniciado em segundo plano. Aguarde alguns instantes e acesse eSocial > Lotes para acompanhar o processo."
            );
          } else {
            this.edAlert(result.msg, "error");
          }
        });
      });
    },

    onBulkGerarXml(ids) {
      this.onGerarArquivoXML(ids, this.formData.layout);
    },

    onGerarArquivoXML(ids,layout = null) {
      this.$confirm(
        "Tem certeza que deseja gerar o xml dos registro(s) selecionados?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.config.loading.content = true;
        this.$root.$loading.set(true);

        var filter = {
          ids: ids,
          avulso:this.avulso
        };

        this.get("esocial/" + (layout ? layout : this.formData.layout) + "/gerar-arquivo-xml", {
          filter: filter,
        }).then((result) => {
          result = result[0];

          this.config.loading.content = false;
          this.$root.$loading.set(false);

          this.getEsocial();

          if (result.status == 200) {
            this.edMsg("Operação realizada com sucesso");
          } else {
            this.edAlert(result.msg, "error");
          }
        });
      });
    },

    onDownloadXML(data) {
      if (!data.xml) return;

      var filename = data.uid + ".xml";
      var content = atob(data.xml);

      this.xmlViewMode = "arvore";
      this.xmlPreview = {
        content: content,
        filename: filename,
        blob: this.b64toBlob(data.xml, "application/xml"),
        campos: this.xmlToCampos(content),
      };

      this.showModalDownloadXML = true;
    },

    xmlToCampos(xml) {
      var campos = [];

      try {
        var doc = new DOMParser().parseFromString(xml, "text/xml");

        var percorrer = function (node, caminho) {
          var filhosElemento = Array.from(node.childNodes).filter((n) => n.nodeType === 1);

          if (!filhosElemento.length) {
            var valor = (node.textContent || "").trim();

            if (valor) {
              campos.push({ caminho: caminho, valor: valor });
            }

            return;
          }

          filhosElemento.forEach((filho) => {
            percorrer(filho, caminho ? caminho + " > " + filho.nodeName : filho.nodeName);
          });
        };

        if (doc.documentElement) {
          percorrer(doc.documentElement, doc.documentElement.nodeName);
        }
      } catch (e) {
        campos = [];
      }

      return campos;
    },

    downloadXMLPreview() {
      if (!this.xmlPreview.blob) return;

      this.download(this.xmlPreview.blob, this.xmlPreview.filename);
    },

    onDispararWhatsappAtualizarMatriculaContador(data) {
      var self = this;
      var idFuncionario = data.funcionario ? data.funcionario.id : data.id_fun;

      this.$confirm(
        "Enviar WhatsApp ao contador solicitando a correção da matrícula/categoria do funcionário?",
        "Atenção",
        { type: "warning" }
      ).then(() => {
        self.post("esocial/funcionario/" + idFuncionario + "/disparar-whatsapp-atualizar-matricula-contador", {}).then((result) => {
          result = result[0];

          if (result.status == 200 && result.data.success) {
            self.edMsg("WhatsApp enviado ao contador com sucesso.");
          } else {
            self.edMsg((result.data && result.data.message) || "Não foi possível enviar o WhatsApp.", "error");
          }
        });
      });
    },

    onBulkDispararWhatsappAtualizarMatriculaContador(ids) {
      var self = this;

      this.$confirm(
        ids.length + " registro(s) selecionado(s). Enviar WhatsApp ao contador de cada um solicitando a correção da matrícula?",
        "Atenção",
        { type: "warning" }
      ).then(() => {
        self.post("esocial/disparar-whatsapp-atualizar-matricula-contador-lote", { ids: ids }).then((result) => {
          result = result[0];

          if (result.status == 200 && result.data.success) {
            self.edMsg(result.data.message || "WhatsApp(s) enviado(s) ao contador com sucesso.");
          } else {
            self.edMsg((result.data && result.data.message) || "Não foi possível enviar o(s) WhatsApp.", "error");
          }

          self.getEsocial();
        });
      });
    },

    onUpdateUid(data)
    {
      this.olduid = data.uid;
      this.novoUid = data.uid;
      this.novoRecibo = data.recibo;
      this.reciboManualInfo = data.usuario_recibo_manual
        ? {
            usuario: data.usuario_recibo_manual.usuario,
            data: this.toDate(data.recibo_manual_at),
          }
        : null;
      this.showModalUid = !this.showModalUid;
    },

    saveUid()
    {
      this.$root.$loading.set(true);
      this.config.loading.content = true;

      this.post("esocial/update-uid", 
      { 
        novoUid: this.novoUid, 
        antigoUid: this.olduid,
        novoRecibo: this.novoRecibo,
      }
      ).then((result) => {
          result = result[0];

          this.config.loading.content = false;
          this.$root.$loading.set(false);

          if (result.status == 200) {
              this.showModalUid = !this.showModalUid;
              this.edMsg("Operação realizada com sucesso");

              this.getEsocial();
          }
      });
    },

    onLogs(data) {
      this.formData.item = data;
      this.showLogs = !this.showLogs;
    },

    getEsocialTabela(_search, _page, _pagination) {
      
      this.config.loading.esocial_tabela = true;
      this.config.list.esocial_tabela = [];

      this.get("esocial/tabelas/conteudo/9", {
        page: _page,
        search: _search,
        pagination: _pagination,
        filter: this.formFilter,
      }).then((result) => {
        result = result[0];

        this.config.loading.esocial_tabela = false;

        if (result.status == 200) {
          this.config.list.esocial_tabela = result.data.data;

          if (this.config.list.esocial_tabela.length && !this.formData.esocial_tabela) {
            this.formData.esocial_tabela = this.config.list.esocial_tabela[0];
            this.formData.layout = this.config.list.esocial_tabela[0].codigo;
          }
        }
      });
    },

    getEsocial (_search = this.formData.search, _page = this.formData.page, _pagination = this.formData.pagination) {

      this.filterBadge =
        (this.formFilter.id_empresa ? 1 : 0) +
        (this.formFilter.id_fdt ? 1 : 0) +
        (this.formFilter.id_funcionario ? 1 : 0) +
        (this.formFilter.empresa_envio_automatico ? 1 : 0) +
        (this.formFilter.data_cadastro &&
        this.formFilter.data_cadastro[0] &&
        this.formFilter.data_cadastro[1]
          ? 1
          : 0) +
        (this.formFilter.mostrar && this.formFilter.mostrar.length > 0 ? 1 : 0) +
        (this.formFilter.id_tipo_status && this.formFilter.id_tipo_status.length > 0 ? 1 : 0) +
        (this.formFilter.motivo_falha_geracao && this.formFilter.motivo_falha_geracao.length > 0 ? 1 : 0) +
        (this.formFilter.tp_exa && this.formFilter.tp_exa.length > 0 ? 1 : 0);

        if(this.lote){
        this.formFilter['lote'] = this.lote
      }

      this.formData.search = _search;
      this.formData.page = _page;
      this.formData.pagination = _pagination;

      this.config.loading.table = true;
      this.response = {};
      this.pagination = {};

      this.config.loading.tableAntigo = true;
      this.responseAntigo = {};
      this.paginationAntigo = {};

      if(this.layout){
        this.formData.layout = this.layout
      }

      let url = "esocial/" + this.formData.layout
      if(this.avulso){
        url = "esocial/avulso"
      }

      this.get(url, {
        page: _page,
        search: _search,
        pagination: _pagination,
        filter: this.formFilter,
      }).then((result) => {
        result = result[0];
        this.response = result;
        this.config.loading.table = false;

        if (result.status == 200) {
          this.pagination = result;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.esocial-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  flex-wrap: nowrap;
}

.esocial-tabs {
  display: flex;
  align-items: stretch;
  gap: 2px;
  background: #f0f1f3;
  border-radius: 8px;
  padding: 3px;
  height: 36px;
  flex: 1 1 calc(50% - 6px);
  min-width: 0;

  &--xml {
    flex: none;
    width: 220px;
    margin: 14px 24px 0;
  }
}

.esocial-tabs__item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 10px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background-color 0.15s, color 0.15s, box-shadow 0.15s;

  i {
    font-size: 11px;
  }

  &:hover:not(.is-active) {
    color: #374151;
  }

  &.is-active {
    background: #fff;
    color: #1f2329;
    font-weight: 600;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
}

.esocial-search {
  display: flex;
  align-items: stretch;
  gap: 8px;
  flex: 1 1 calc(50% - 6px);
  min-width: 0;
  justify-content: flex-end;
}

.esocial-search__group {
  display: flex;
  align-items: stretch;
  height: 36px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #d0d4d9;
  border-radius: 8px;
  overflow: hidden;
  flex: 1 1 auto;
  min-width: 160px;
  transition: border-color 0.15s;

  &:focus-within {
    border-color: #09f;
  }
}

.esocial-search__input {
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  padding: 0 12px;
  flex: 1 1 auto;
  min-width: 0;

  i {
    color: #9aa0a8;
    font-size: 12px;
  }

  input {
    border: none;
    background: transparent;
    outline: none;
    font-size: 12px;
    color: #1f2329;
    width: 100%;
    height: 100%;

    &::placeholder {
      color: #9aa0a8;
    }
  }
}

.esocial-search__btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  box-sizing: border-box;
  padding: 0 14px;
  border: 1px solid #e4e7ed;
  background: #fff;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background-color 0.15s, border-color 0.15s;

  &:hover {
    background: #f7f8f9;
  }

  &--attached {
    height: 100%;
    border: none;
    border-left: 1px solid #d0d4d9;
    border-radius: 0;
    background: #f7f8f9;

    &:hover {
      background: #eef0f2;
    }
  }

  &--filter {
    position: relative;
    color: rgb(168, 121, 31);
    border-color: #f0dfb8;
    background: #fdf8ee;

    &:hover {
      background: #f5e6c3;
    }
  }
}

.esocial-search__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  background: rgb(168, 121, 31);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}

.esocial-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1500;
}

.esocial-modal {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  width: 620px;
  max-width: 92vw;
  max-height: 85vh;
  overflow: hidden;

  &--xml {
    width: 900px;
    max-width: 92vw;
  }
}

.esocial-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 3px solid rgba(168, 121, 31, 0.45);
}

.esocial-modal__title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2329;
}

.esocial-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #f1f2f4;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    background: #e4e7ed;
    color: #1f2329;
  }
}

.esocial-modal__body {
  padding: 20px 22px;
  overflow-y: auto;
  flex: 1 1 auto;

  &--xml {
    padding: 0;
    max-height: 65vh;
    background: #f7f9fb;
  }
}

.xml-preview {
  padding: 14px 24px 18px;
  font-size: 12px;
  line-height: 1.7;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
}

.xml-table {
  padding: 14px 24px 18px;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }

  thead th {
    text-align: left;
    padding: 8px 10px;
    background: #eef0f2;
    color: #6b7280;
    font-size: 10.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    position: sticky;
    top: 0;
  }

  tbody tr {
    border-bottom: 1px solid #eef0f2;

    &:hover {
      background: #f0f4ff;
    }
  }

  td {
    padding: 7px 10px;
    vertical-align: top;
  }
}

.xml-table__campo {
  width: 45%;
  color: #6b7280;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 11px;
  word-break: break-word;
}

.xml-table__valor {
  color: #1f2329;
  font-weight: 600;
  word-break: break-word;
}

.xml-table__empty {
  text-align: center;
  color: #9aa0a8;
  padding: 30px 0;
  font-size: 12px;
}

.esocial-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 22px;
  border-top: 1px solid #eef0f2;
}

.esocial-modal__btn-download {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 52px;
  border: none;
  border-radius: 10px;
  background: #1a8a3e;
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.15s;

  i {
    font-size: 16px;
  }

  &:hover {
    background: #146b2e;
  }
}

.esocial-modal-fade-enter-active,
.esocial-modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.esocial-modal-fade-enter,
.esocial-modal-fade-leave-to {
  opacity: 0;
}
</style>

<!--
  Sem "scoped": o MessageBox do Element UI (this.$confirm) é montado direto no
  <body>, fora do componente — estilo com data-v- aqui não chegaria nele.
-->
<style lang="scss">
.esocial-confirm-box {
  width: 420px;
  border-radius: 12px;

  .el-message-box__header {
    padding-bottom: 8px;
  }

  .el-message-box__title {
    font-weight: 700;
  }

  .el-message-box__content {
    padding-top: 4px;
  }

  .el-message-box__btns {
    padding-top: 16px;

    .el-button--primary {
      background: #217a34;
      border-color: #217a34;

      &:hover,
      &:focus {
        background: #1c6b2c;
        border-color: #1c6b2c;
      }
    }
  }
}

.esocial-confirm {
  &__lead {
    margin: 0 0 12px;
    font-size: 13px;
    line-height: 1.5;
    color: #4b5563;

    b {
      color: #1f2937;
    }
  }

  &__alvo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: #f5f7f9;
    border: 1px solid #e4e7ed;
    border-radius: 8px;

    i {
      font-size: 22px;
      color: #9aa4b2;
    }

    div {
      display: flex;
      flex-direction: column;
      min-width: 0;
    }

    strong {
      font-size: 13px;
      color: #1f2937;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    span {
      font-size: 11px;
      color: #6b7280;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?34a4739e